export enum VehicleTabViewVariant {
  REQUIRED_INFO = "required-info",
  OPTIONAL_INFO = "optional-info",
  PHOTOS = "photos",
  FEATURES = "features",
  PRICING = "pricing",
  BOOKING_TOOL_SETTINGS = "booking-tool-settings",
}
